import { render, staticRenderFns } from "./WorkReview.vue?vue&type=template&id=323ec4c8&scoped=true&"
import script from "./WorkReview.vue?vue&type=script&lang=js&"
export * from "./WorkReview.vue?vue&type=script&lang=js&"
import style0 from "./WorkReview.vue?vue&type=style&index=0&id=323ec4c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ec4c8",
  null
  
)

export default component.exports